<template>
  <unicom-layout-cartao semFiltro>
    <div v-if="!loading">
      <ValidationObserver v-slot="{ invalid }">
        <unicom-linha>
          <unicom-coluna sm="12">
            <div class="titulo negrito cor-fonte fonte-primaria">
              Data de Envio do PTU
            </div>
          </unicom-coluna>
        </unicom-linha>
        <unicom-linha class="mt-4" alinharItem="end" style="min-height: 80px">
          <unicom-coluna sm="12" md="3" alinhamento="start">
            <ValidationProvider
              name="primeiro"
              :rules="{
                required: true,
                regex: /\b(0?[1-9]|[1-2][0-9]|3[0-1])\b/
              }"
              :customMessages="{
                regex: 'Este valor excede a quantidade de dias válidos.'
              }"
              immediate
              v-slot="{ errors }"
            >
              <unicom-campo-texto
                maxCaracteres="2"
                apenasNumero
                colorPlaceholder="#9E9E9E"
                placeholder="Digite um dia de envio válido"
                titulo="1º Dia de envio"
                v-model="objetoDataNotificacao.primeiroDia"
                :mensagemErro="errors[0]"
              />
            </ValidationProvider>
          </unicom-coluna>
          <unicom-coluna
            sm="12"
            md="3"
            alinhamento="start"
            :class="$breakpoint.smAndDown ? 'mt-2' : ''"
          >
            <ValidationProvider
              name="segundo"
              :rules="{
                required: true,
                regex: /\b(0?[1-9]|[1-2][0-9]|3[0-1])\b/
              }"
              :customMessages="{
                regex: 'Este valor excede a quantidade de dias válidos.'
              }"
              immediate
              v-slot="{ errors }"
            >
              <unicom-campo-texto
                maxCaracteres="2"
                apenasNumero
                colorPlaceholder="#9E9E9E"
                placeholder="Digite um dia de envio válido"
                titulo="2º Dia de envio"
                v-model="objetoDataNotificacao.segundoDia"
                :mensagemErro="errors[0]"
              />
            </ValidationProvider>
          </unicom-coluna>
          <unicom-coluna sm="12" md="auto" alinhamento="center">
            <unicom-linha>
              <unicom-coluna
                sm="12"
                md="auto"
                :class="$breakpoint.smAndDown ? 'mt-2' : ''"
              >
                <unicom-botao
                  :bloco="$breakpoint.smAndDown"
                  :desabilitado="invalid"
                  :largura="144"
                  @click="$emit('salvar-data', objetoDataNotificacao)"
                >
                  SALVAR
                </unicom-botao>
              </unicom-coluna>
            </unicom-linha>
          </unicom-coluna>
        </unicom-linha>
      </ValidationObserver>
    </div>
    <div v-else>
      <unicom-spinner
        style="min-height: 130px; display: flex; align-items: center"
        v-show="loading"
        :tamanhoLoading="62"
        :tamanhoLinha="7"
        :velocidade="0.5"
        :marginTopTexto="30"
      />
    </div>
  </unicom-layout-cartao>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    objetoDataNotificacaoProp: {
      primeiroDia: "",
      segundoDia: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      objetoDataNotificacao: {
        primeiroDia: "",
        segundoDia: ""
      }
    };
  },
  watch: {
    objetoDataNotificacaoProp: {
      deep: true,
      immediate: true,
      handler() {
        this.objetoDataNotificacao = JSON.parse(
          JSON.stringify(this.objetoDataNotificacaoProp)
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
